import React, { Component } from "react";
import { CertificateList } from "../helpers/CertificateList";
import * as ReactTooltip from "react-tooltip";
import { Tooltip } from "react-tooltip";

const Certificate = () => {
  return (
    <div className="projects">
      <h1> Certifications</h1>
      <div className="projectList">
        {CertificateList.map((cer) => {
          console.log(cer.company);
          return (
            <>
              <div className="projectItem">
                <div
                  style={{ backgroundImage: `url(${cer.image})` }}
                  className="bgImage"
                />
                <h4> {cer.name} </h4>
                <Tooltip
                  id="myTooltip"
                  effect="solid"
                  place="bottom"
                  type="info"
                  className="my-custom-tooltip"
                />
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};

export default Certificate;
